import { render } from "./PaymentUpdate.vue?vue&type=template&id=13822518"
import script from "./PaymentUpdate.vue?vue&type=script&lang=js"
export * from "./PaymentUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/home/undanet/pej22-webadmin/front-end/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__